module.exports = __webpack_public_path__ + "img/ear02.e11a2730.png";